/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:44:20
 * @LastEditTime: 2023-03-01 14:26:05
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-intelligent-clean\index.js
 * 流向智能清洗路由
 */
import dayReportRouter from './modules/dayReportRouter'
import monthReportRouter from './modules/monthReportRouter'
import weekRepotRouter from './modules/weekReportRouter'
const flowIntelligentCleanRouter = [].concat(
  dayReportRouter,
  weekRepotRouter,
  monthReportRouter,
)
export default flowIntelligentCleanRouter
